/**
 * The id length of each action.
 */
export const ACTION_ID_LENGTH = 80;

export const MESSAGE_ID = 'rc-apps-engine-ui';
